// extracted by mini-css-extract-plugin
export default {"avatar":"MYCG8R"};